import styled, { css } from 'styled-components'
import styleguide from 'styleguide'
import { IconDown, IconUp, Button, TextSubHeading } from 'blocket-ui'

const commonStyles = css`
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
`

const StyledSelect = styled.div`
  display: flex;
  flex-grow: 1;
  -webkit-touch-callout: none; /* iOS Safari */
  user-select: none;
  min-width: 0;

  .select {
    position: relative;
    display: flex;
    z-index: 99;
    width: 100%;
    min-width: 0;

    &.open .selection {
      outline: 0;
    }

    .selection {
      position: relative;
      background: transparent;
      color: #fff;
      height: 40px;
      line-height: 40px;
      padding: 0px 16px 0px 8px;
      text-align: left;

      .placeholder {
        color: #ffffff;
        line-height: inherit;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .dropdown {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background: #fff;
      width: 305px;
      border-radius: ${styleguide.border.radius.medium}px;
      box-shadow: 0px 2px 8px 0px ${styleguide.color.gray50};
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      max-height: 634px;
      outline: 0;

      label {
        font-size: 16px !important;

        > div[class^='CheckBox'] {
          margin-right: 14px;
        }
      }

      &.align-right {
        left: auto;
        right: 0;
      }

      .options-wrapper {
        overflow: auto;
        ${commonStyles}
        display: flex;
        flex-direction: column;
        max-height: inherit;
      }

      .options-top {
        border-bottom: 1px solid #eee;
        padding: 7px 0;
        flex-shrink: 0;
      }

      .options {
        height: auto;
        overflow-y: scroll;
        ${commonStyles}
        padding: 7px 0;
      }

      .option {
        cursor: pointer;
        display: flex;

        &:not(.selected) > .option-inner:hover {
          background: #efefef;
        }
        &.focused {
          background: #f5f5f5;
        }
        &.disabled {
          opacity: 0.35;
          pointer-events: none;
        }

        .option-checkbox label > div {
          pointer-events: none;
        }

        .option-inner {
          display: flex;
          flex-grow: 1;
          align-items: center;

          .option-toggler {
            display: block;
            width: 100%;
            align-items: center;
            padding: 5px 15px;
            outline: 0;
            overflow: hidden;
            white-space: nowrap;

            .checkbox {
              margin-right: 16px;
              display: inline-block;
            }
          }
        }

        &.parent {
          flex-direction: column;

          .option-parent-toggle {
            margin-left: auto;
            display: flex;
            display: flex;
            align-items: center;
            width: auto;
            outline: 0;
            cursor: inherit;
            width: 48px;
            height: 100%;
            justify-content: center;
            background-color: transparent;
          }

          .option-children {
            display: none;
            overflow: auto;
            background-color: #f9f7f6;

            .option-toggler {
              padding-left: 22px;
            }

            .option.focused {
              background: #eeeeee;
            }
          }

          &.open .option-children {
            display: block;
          }
        }
      }
    }

    .action-buttons {
      padding: 8px 15px;
      background-color: #ffffff;
      border-top: 1px solid #eee;
      display: flex;
      flex-shrink: 0;
    }
  }
`

export const StyledSubAreaLables = styled.div`
  font-size: 12px;
  line-height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #9a9999;
  padding-left: 32px;
`

export const StyledIconDown = styled(IconDown)`
  position: absolute;
  pointer-events: none;
  right: 0px;
  top: 13px;
  color: #fff;
`

export const StyledIconUp = styled(IconUp)`
  position: absolute;
  pointer-events: none;
  right: 0px;
  top: 13px;
  color: #fff;
`

const sharedButtonStyle = css`
  button {
    height: 40px;

    * {
      color: inherit;
    }
  }
`

export const StyledClearButton = styled(Button)`
  ${sharedButtonStyle}
  margin-right: 10px;
`

export const StyledConfirmButton = styled(Button)`
  width: 100%;
  ${sharedButtonStyle}
`

export const StyledButtonText = styled(TextSubHeading)``

export default StyledSelect
